import React from 'react';
import GoalMapping from '../Visualizations/GoalMapping';
import Goals, {Goal} from '../Goals/Goals';

import { WorkshopStepProps } from './WorkshopStep';
import WorkshopComponent from './WorkshopComponent';


const GoalAlignmentWorkshop: React.FC = () => {
  const [goals, setGoals] = React.useState<Goal[]>([]);

  const steps: WorkshopStepProps[] = [
    {
      title: 'Update Your Goals',
      number: 1,
      children: <Goals onGoalsChange={setGoals} />,
      canProceed: goals.length > 0,
    },
    {
      title: 'Goal Alignment',
      number: 2,
      children: <GoalMapping />,
      canProceed: false,
    },
  ]

  return (
    <WorkshopComponent title="Goal Alignment" steps={steps} />
  );
};


export default GoalAlignmentWorkshop;

